import React from 'react';
import { CustomerDecisionOptionsType, ProductItem, ExpectedAlternativeProductData, REJECT_ALTERNATIVE } from "./AlternativeOfferModal";
import { ProductCard } from "./ProductCard";
import Arrow from './Arrow/Arrow';
import * as translator from "../../../utils/translator";
import { useParams } from 'react-router-dom';

type Props = {
    onCustomerChoiceChange: (originalProductItemID: number, alternativeProductItemID: CustomerDecisionOptionsType) => void;
    originalProduct: ProductItem;
    alterantiveProduct: ExpectedAlternativeProductData;
}

export const AlternativeProductOfferContainer: React.FC<Props> = ({
    onCustomerChoiceChange,
    originalProduct,
    alterantiveProduct
}) => {
    
    const { country } = useParams();

    if (!alterantiveProduct) return null;
    
    return (
        <div className="alternative-product-offer-container">
            {/* "alternative for" title */}
            <p className="alternative-for">Alternative für
                <span className="alternative-for-original-product-name"> {originalProduct.title}</span>
            </p>

            {/* product cards + continuation arrow */}
            <div className="alternative-product-transition-container">
                {/* original product picked by the user */}
                <ProductCard
                    cbd={originalProduct.cannabisCatalogProductProperties.cbd}
                    thc={originalProduct.cannabisCatalogProductProperties.thc}
                    strain={originalProduct.cannabisCatalogProductProperties.strain}
                    imageSrc={originalProduct.imageSrc}
                    titleView={originalProduct.titleView}
                    price={originalProduct.price}
                    catalogPage={originalProduct.catalogPage}
                    isOutOfStock={true}
                />

                {/* continuation arrow: "out of stock" --> "alternative" */}
                <Arrow thickness={1} size={30} />

                {/* alternative offer product */}
                <ProductCard
                    cbd={alterantiveProduct.cbd}
                    thc={alterantiveProduct.thc}
                    strain={alterantiveProduct.strain}
                    imageSrc={alterantiveProduct.imageSrc}
                    titleView={alterantiveProduct.titleView}
                    price={alterantiveProduct.price}
                    catalogPage={alterantiveProduct.catalogPage}
                />
            </div>

            {/* action buttons */}
            <div className="alternative-offer-actions-container">
                {/* accept alternative */}
                <button
                    className="accept-offer-button action-button"
                    id="accept-alternative-button"
                    onClick={() => onCustomerChoiceChange(originalProduct.product_item_id, alterantiveProduct.productItemID)}
                >
                    {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/accept_alternative")}
                </button>

                {/* cancel oder / reject alternative */}
                <button
                    className="reject-offer-button"
                    id="reject-offer-button"
                    onClick={() => onCustomerChoiceChange(originalProduct.product_item_id, REJECT_ALTERNATIVE)}
                >
                    {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/cancel_order")}
                </button>
            </div>
        </div>
    );
} 